import { useState, useRef } from "react";
import { ClipLoader } from "react-spinners";
import "./ChatInput.css";

import arrowup from "../../assets/arrowup.svg";
import trash from "../../assets/trash.svg";
import thumbsdown from "../../assets/thumbsdown.svg";

export const handleClearMessages = () => {
  localStorage.setItem("qAndAPairs", JSON.stringify([]));
  console.log("Local storage cleared.");
  window.location.reload();
};

function ChatInput({ handleAddQAndAPair, onChange, onSubmit, value }) {
  const [question, setQuestion] = useState(value);
  const [answer, setAnswer] = useState("");
  const inputRef = useRef(null);

  function handleChange(e) {
    setQuestion(e.target.value);
    onChange(e.target.value);
    console.log(question);
  }
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      inputRef.current.click();
    }
  };
  function handleSubmit(e) {
    e.preventDefault();
    onSubmit(question);
    setQuestion("");
  }

  return (
    <div className="max-w-full w-full">
      <form
        onSubmit={(e) => e.preventDefault()}
        className="relative w-full autofill:content-none"
      >
        <input
          autoComplete="off"
          value={question}
          onKeyDown={handleKeyDown}
          //   className="border border-black rounded-md p-2 lg:w-[900px] md:w-[520px] w-[400px] xl:w-[1024px] inputQuestion "
          className="border border-black rounded-md p-2 w-full inputQuestion "
          onChange={handleChange}
          placeholder="Type your question here..."
        ></input>

        <img
          alt="submit"
          onClick={handleSubmit}
          className="w-6 glass"
          src={arrowup}
          ref={inputRef}
        ></img>

        <img
          alt="delete"
          onClick={handleClearMessages}
          className="w-6 trash"
          src={trash}
        ></img>
      </form>
    </div>
  );
}

export default ChatInput;
